import React, { useEffect, useState } from "react";
import { Paper, Box, Typography } from "@mui/material";
import { filteredListItems } from "../sharedComponents/PanelList";
import { DocumentAutocomplete } from "./navigationComponents/DocumentAutocomplete";
import { NavigationIcons } from "./navigationComponents/NavigationIcons";
import { NavigationButtons } from "./navigationComponents/NavigationButtons";

export const NavigationList = ({
  menuOpen,
  handleItemClick,
  documentID,
  setDocumentID,
  setNameDocument,
  selectedItem,
  rol,
  documents,
  documentsLoading,
}) => {
  const [selectedButton, setSelectedButton] = useState(selectedItem);

  const ListItems = filteredListItems(rol);

  const handleButtonClick = (id) => {
    setSelectedButton(id);
    handleItemClick(id);
  };
  useEffect(() => {
    if (!documentID && selectedButton !== 0 && selectedButton !== 8  && selectedButton !== 12 && selectedButton !== 13 && selectedButton !== 9) {
      setSelectedButton(0);
      handleItemClick(0);
    }
  }, [documentID, selectedButton, handleItemClick]);

  const ListComponent = ListItems.map((item) =>
    !menuOpen ? (
      <NavigationIcons
        key={item.id}
        item={item}
        selectedButton={selectedButton}
        handleButtonClick={handleButtonClick}
        documentID={documentID}
      />
    ) : (
      <NavigationButtons
        key={item.id}
        item={item}
        selectedButton={selectedButton}
        handleButtonClick={handleButtonClick}
        documentID={documentID}
      />
    )
  );

  return (
    <Paper
      elevation={0}
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          marginBottom: "50px",
          marginTop: "30px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {!menuOpen ? (
          <Typography variant="h5" component="div" fontWeight="bold" color="primary">
            E
          </Typography>
        ) : (
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h5" component="div" fontWeight="bold" color="primary">
              EDITOR{" "}
              <Typography component="span" sx={{ fontSize: "0.7em", color: "error.main", verticalAlign: "middle" }}>
                v.26
              </Typography>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              SIGEDI
            </Typography>
          </Box>
        )}
      </div>
      <div
        style={{
          marginBottom: "25px",
        }}
      >
        <DocumentAutocomplete
          documentID={documentID}
          setDocumentID={setDocumentID}
          setNameDocument={setNameDocument}
          documents={documents}
          loading={documentsLoading}
        />
      </div>
      <div
        style={{
          flexGrow: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {ListComponent}
      </div>
    </Paper>
  );
};
